function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9788 39.3524L20.2992 39.6304C20.5501 39.3406 20.8807 38.9151 21.279 38.3726C22.6691 36.4774 24.8712 33.1395 27.0105 29.3829C29.1499 25.6247 31.2265 21.4528 32.3555 17.8708L31.952 17.7437L32.3487 17.8946C32.9013 16.4384 33.2082 14.8585 33.2082 13.2073C33.2065 5.91287 27.2936 0 20.0008 0C12.7064 0 6.79353 5.91287 6.79353 13.2073C6.79353 14.1855 6.90371 15.1365 7.10375 16.0536L7.51738 15.962L7.76488 15.6179H7.76149L6.84608 14.9551L7.10036 16.0536C7.1207 16.1434 7.14274 16.2316 7.16308 16.3163C7.18851 16.4197 7.21394 16.5265 7.24275 16.6333V16.6299C7.77844 18.693 8.69554 21.007 9.79912 23.3616C11.4553 26.8927 13.5353 30.512 15.3899 33.4718C16.3172 34.9517 17.1902 36.2655 17.9259 37.3216C18.6633 38.3777 19.26 39.1727 19.655 39.6304L19.9754 40L20.2958 39.6304L19.9754 39.3524L20.2958 39.0744C20.0585 38.8015 19.7144 38.359 19.299 37.7878C17.8395 35.7857 15.478 32.1868 13.2607 28.2166C12.1521 26.2316 11.0773 24.1516 10.167 22.1326C9.25835 20.1136 8.51246 18.1539 8.06154 16.4163V16.413C8.03441 16.3163 8.01068 16.218 7.98525 16.1163C7.96491 16.0281 7.94287 15.9434 7.92423 15.862L7.5106 15.9569L7.2631 16.3011H7.26649L8.16664 16.9537L7.92762 15.8688C7.73945 15.0093 7.63604 14.1193 7.63604 13.2056C7.63604 9.79149 9.01933 6.70453 11.2553 4.46686C13.4997 2.23089 16.5867 0.847601 20.0008 0.847601C23.415 0.847601 26.502 2.23089 28.7396 4.46686C30.9773 6.70453 32.3589 9.79149 32.3589 13.2056C32.3589 14.7517 32.0724 16.2282 31.5554 17.5911L31.552 17.6013L31.5469 17.6149C30.2958 21.5935 27.7903 26.4299 25.3628 30.5306C24.149 32.5818 22.9539 34.4516 21.9452 35.9417C21.4418 36.6876 20.9841 37.3385 20.5942 37.8691C20.206 38.3997 19.8822 38.8117 19.6567 39.0727L19.9771 39.3507L19.9788 39.3524Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9788 39.3524C21.8876 37.1487 29.4092 25.8145 31.952 17.7437C32.4877 16.3333 32.7827 14.8059 32.7827 13.2073C32.7827 6.1468 27.0597 0.423798 20.0008 0.423798C12.942 0.423798 7.21732 6.1468 7.21732 13.2073C7.21732 14.1532 7.32243 15.0737 7.51907 15.962H7.51568C7.53602 16.0451 7.55636 16.1315 7.5784 16.218C7.60383 16.3214 7.62926 16.4231 7.65638 16.5248C9.76013 24.6228 17.9734 37.0351 19.9805 39.3524H19.9788Z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "buffers"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 8H13V11H27V8ZM13 7C12.4477 7 12 7.44772 12 8V11C12 11.5523 12.4477 12 13 12H27C27.5523 12 28 11.5523 28 11V8C28 7.44772 27.5523 7 27 7H13Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.4667 12H14.0667V13H18.4667V12ZM13.0667 11V13C13.0667 13.5523 13.5144 14 14.0667 14H18.4667C19.019 14 19.4667 13.5523 19.4667 13V11H13.0667Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.9333 12H21.5333V13H25.9333V12ZM20.5333 11V13C20.5333 13.5523 20.981 14 21.5333 14H25.9333C26.4856 14 26.9333 13.5523 26.9333 13V11H20.5333Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4 14H15.1333V17H17.4V14ZM14.1333 13V18H18.4V13H14.1333Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.8667 14H22.6V17H24.8667V14ZM21.6 13V18H25.8667V13H21.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4 18H15.1333V21H17.4V18ZM14.1333 17V22H18.4V17H14.1333Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.8667 18H22.6V21H24.8667V18ZM21.6 17V22H25.8667V17H21.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0667 21C13.5144 21 13.0667 21.4477 13.0667 22C13.0667 22.5523 13.5144 23 14.0667 23H18.4667C19.019 23 19.4667 22.5523 19.4667 22C19.4667 21.4477 19.019 21 18.4667 21H14.0667Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5333 21C20.981 21 20.5333 21.4477 20.5333 22C20.5333 22.5523 20.981 23 21.5333 23H25.9333C26.4856 23 26.9333 22.5523 26.9333 22C26.9333 21.4477 26.4856 21 25.9333 21H21.5333Z",
  fill: "white"
}));

var SvgBufferStop = function SvgBufferStop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBufferStop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buffer-stop.e26726bd.svg";
export { ForwardRef as ReactComponent };